import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=a8c62e28"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c62e28')) {
      api.createRecord('a8c62e28', component.options)
    } else {
      api.reload('a8c62e28', component.options)
    }
    module.hot.accept("./UserAvatar.vue?vue&type=template&id=a8c62e28", function () {
      api.rerender('a8c62e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/UserMenu/UserAvatar.vue"
export default component.exports